import React from 'react';

import {Dialogue, Button, Anchor, Text} from '@albert-io/atomic';

interface Props {
  className: string;
  handleClose: () => void;
}

const LaunchContextNotFound = ({className, handleClose}: Props) => (
  <Dialogue hideCloseBtn className={className} size='m' title=''>
    <Dialogue.Body>
      <div className='u-display_flex u-flex-direction_column'>
        <Text className='u-mar-b_3'>
          Too much time has passed since you launched from your LMS platform. To import a roster,
          please re-launch from the platform.
        </Text>
        <Anchor href='https://help.albert.io/en/articles/5350870-how-do-i-use-canvas-on-albert-as-a-teacher#h_3303c5848e'>
          Check out our help article for additional details.
        </Anchor>
      </div>
    </Dialogue.Body>
    <Dialogue.BtnGroup>
      <Button onClick={() => handleClose()}>Dismiss</Button>
    </Dialogue.BtnGroup>
  </Dialogue>
);

export default LaunchContextNotFound;
